import { render, staticRenderFns } from "./Directories.vue?vue&type=template&id=34801606&scoped=true"
import script from "./Directories.vue?vue&type=script&lang=js"
export * from "./Directories.vue?vue&type=script&lang=js"
import style0 from "./Directories.vue?vue&type=style&index=0&id=34801606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34801606",
  null
  
)

export default component.exports